import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { IconTrash } from '@tabler/icons-react';
import { getLanguageLabel } from '../../lib/languageUtils';

const TranslationRow = ({ 
    translation, 
    sentenceIndex, 
    originalIndex, 
    updateTranslation, 
    deleteTranslation 
}) => {
    return (
        <div className="flex gap-2 items-start p-3 border rounded-md bg-muted/20">
            <div className="flex-1">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-2 items-end">
                    <div className="md:col-span-1">
                        <label className="text-xs text-muted-foreground">Language</label>
                        <div className="text-sm font-medium text-foreground truncate">
                            {getLanguageLabel(translation.language_code)}
                        </div>
                    </div>
                    <div className="md:col-span-1">
                        <label className="text-xs text-muted-foreground">Code</label>
                        <Input
                            value={translation.language_code || ''}
                            placeholder="en"
                            className="h-8 bg-muted text-center"
                            readOnly
                        />
                    </div>
                    <div className="md:col-span-10">
                        <label className="text-xs text-muted-foreground">Translation</label>
                        <Input
                            value={translation.text || ''}
                            onChange={(e) => updateTranslation(sentenceIndex, originalIndex, 'text', e.target.value)}
                            placeholder="Translated text..."
                            className="h-8"
                        />
                    </div>
                </div>
            </div>
            <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => deleteTranslation(sentenceIndex, originalIndex)}
                className="text-destructive hover:text-destructive mt-5"
            >
                <IconTrash className="h-3 w-3" />
            </Button>
        </div>
    );
};

export default TranslationRow; 